import { TranslationService } from '../services/translation.service';
import { TranslationKey } from '../types/translation-keys.type';

let globalTranslationService: TranslationService | null = null;


export function setGlobalTranslationService(service: TranslationService): void {
  globalTranslationService = service;
}

export function t(key: TranslationKey, params?: Record<string, string | number>): string {
  if (!globalTranslationService) {
    return key;
  }
  try {
    const result = globalTranslationService.translate(key, params);
    return result;
  } catch (error) {
    return key;
  }
}
